import React, { useEffect, useRef } from "react";
import styles from "./Options.module.css";
import copy from "copy-text-to-clipboard";

const Options = (props) => {
	const wrapperRef = useRef(null);
	useEffect(() => {
		function handleClickOutside(event) {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				props.toggleOptions(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
		// eslint-disable-next-line
	}, [wrapperRef]);

	return (
		<div ref={wrapperRef} className={styles.main}>
			<button onClick={props.clicked} className={styles.button}>
				Open Link in New Tab
			</button>
			<button
				onClick={(e) => {
					e.stopPropagation();
					copy(props.link);
				}}
				className={styles.button}
			>
				Copy URL
			</button>
		</div>
	);
};

export default Options;
